import { Link } from 'gatsby';
import React from 'react';
import IconLink from '~/components/IconLink';
import Buttons from '~/components/Dynamic/Buttons';
import renderLink from '~/utils/render-link';

function TextCard({
  style,
  heading,
  content,
  tag,
  className,
  buttons,
  button,
  icon,
  iconSrc,
  headingClass,
  contentClass,
  subHeading,
  subHeadingClass,
  buttonClass,
}) {
  const HeadingTag = tag && tag.substr(0, 1) === 'h' ? tag : 'h2';

  return (
    <div className={`flex flex-col ${className}`} style={style}>
      {iconSrc && (
        <div className="flex justify-center">
          {icon && <img className={`w-16 select-none inline-block mb-6`} draggable={false} src={iconSrc} alt={``} />}
        </div>
      )}

      {subHeading && (
        <div className="mb-3">
          <p className={`${subHeadingClass || 'text-sh'} `} dangerouslySetInnerHTML={{ __html: subHeading }} />
        </div>
      )}

      {heading && (
        <HeadingTag
          className={`text-${HeadingTag} mb-3 ${headingClass}`}
          purge-classname="text-h1 text-h2 text-h3 text-h4 text-h5"
          dangerouslySetInnerHTML={{
            __html: heading,
          }}
        />
      )}

      {content && <div className={`prose ${contentClass || ''}`} dangerouslySetInnerHTML={{ __html: content }} />}

      {buttons?.length > 0 && (
        <div className={`flex items-center mt-10 -ml-7 ${buttonClass || ''}`}>
          {buttons.map(({ title, url, type }, i) => (
            <div key={`${title + i}`} className="pl-7">
              {(!type || type.length === 0) && (
                <Link
                  to={renderLink(url || '#')}
                  className={`c-btn c-btn--primary`}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {type === 'icon-link' && <IconLink to={renderLink(url)}>{title}</IconLink>}
            </div>
          ))}
        </div>
      )}

      {/* Storyblok version */}
      {button?.length > 0 && <Buttons blok={button} className="mt-10" />}
    </div>
  );
}

export default TextCard;
